import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  header: PropTypes.string,
  message: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  noCancel: PropTypes.bool,
  dataTestid: PropTypes.string,
};
const defaultProps = {
  onConfirm: null,
  header: '',
  message: '',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  noCancel: false,
  dataTestid: '',
};

export function ModalDialog({
  open,
  setOpen,
  header,
  message,
  onConfirm,
  cancelLabel,
  confirmLabel,
  noCancel,
  dataTestid,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal show={open} onHide={handleClose} data-testid={dataTestid}>
      <Modal.Header closeButton>
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        {!noCancel && (
          <Button variant="secondary" size="sm" onClick={handleClose}>
            {cancelLabel}
          </Button>
        )}
        <Button variant="primary" size="sm" onClick={handleConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalDialog.propTypes = propTypes;
ModalDialog.defaultProps = defaultProps;
